import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Overview from './views/Overview/Overview';
import DetailPage from './views/Detailpage/Detailpage';
import { appConfiguration } from './configuration/app-configuration';
function App() {
    return (_jsx(BrowserRouter, { basename: `${appConfiguration.overviewSlug}`, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Overview, {}) }), _jsx(Route, { path: `/s/*`, element: _jsx(DetailPage, {}) })] }) }));
}
export { App };
